import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollJournalReport extends Layout {
    excludabletextboxGL: ExcludableTextbox;
    excludabletextboxPayee: ExcludableTextbox;
    officePayrollJournalDatasource: DataSource;
    switchSort: Switch;
    textboxCurrency: Textbox;
    textboxDateRange: Textbox;
    textboxReportType: Textbox;
}
